import classNames from 'classnames';
import { Indicator } from '@crazyegginc/hatch';

export function SidebarCollapsiblePanel({ className, children }) {
  return <section className={classNames('z-10 mb-7 shadow-lg', className)}>{children}</section>;
}

export function SidebarPanelHeader({ children, opened, toggleOpened, className }) {
  return (
    <div
      className={classNames(
        'flex w-full items-center bg-woodsmoke-500 px-3 py-2 outline-none sm:px-3.5 flex-col',
        opened ? 'rounded-t' : 'rounded',
        className,
      )}
    >
      <div className="relative flex flex-1 items-center overflow-hidden w-full">
        {children}
        <button className="flex h-3 w-12 items-center justify-center p-2 text-white" onClick={toggleOpened}>
          <Indicator type="expand" up={opened} className="!h-3 !w-3" aria-label="Expand recording meta info" />
        </button>
      </div>
    </div>
  );
}

export function SidebarPanelContent({ children, opened }) {
  if (!opened) return null;

  return children;
}
